export const API_URL = "https://synthetic-backend-basic-mmlcpe4eca-uc.a.run.app"
export const API_URL_AGENT = "https://data-cleaning-agent-mmlcpe4eca-uc.a.run.app"
export const SIGNIN_BENEFITS = [
  "Generate and preview high-quality NLP datasets before downloading.",
  "Upload CSV files to augment and balance real datasets with synthetic data.",
  "Place custom orders for datasets specific to your use case and receive them within 24-48 hours.",
  // "Integrate your own knowledge sources (PDF, JPG) to ensure domain relevance.",
  "Get expert-reviewed data with flexible and customized pricing for high-quality assurance.",
  "Generate data in multiple Indian and foreign languages.",
  "Contribute to our community datasets and become a paid reviewer."
  // "Pay-per-review model for data evaluation by experts."
];